import React from "react";
import { navLinks } from "../mock";
import { ContactLink } from "./ContactLink";
import { SERVICE_LINKS, CITY_LINKS } from "../seoContent";
import BrandLockup from "./BrandLockup";

export default function Footer() {
  return (
    <footer data-testid="site-footer" style={{ background: "var(--green-800)" }}>
      <div className="container grid gap-8 py-8 md:grid-cols-[1.2fr_0.8fr_1fr_1fr]">
        <div className="max-w-[420px]">
          <BrandLockup nameSize="text-[22px]" nameColor="#ffffff" />
          <p className="mt-3 text-[14.5px] leading-relaxed" style={{ color: "rgba(255,255,255,0.78)" }}>
            We buy and sell IT and office equipment. New branded IT products, pre-owned equipment
            and corporate buyback support.
          </p>
        </div>
        <div>
          <h4 className="font-heading text-[13px] font-bold uppercase tracking-[0.14em] text-white">Quick Links</h4>
          <ul className="mt-3 grid gap-1.5">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={`/${l.href}`} data-testid={`footer-link-${l.href.replace("#", "")}`}
                   className="text-[14.5px] transition-colors hover:text-white"
                   style={{ color: "rgba(255,255,255,0.72)" }}>
                  {l.label}
                </a>
              </li>
            ))}
            {CITY_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-city-${l.href.replace("/", "")}`}
                   className="text-[14.5px] transition-colors hover:text-white"
                   style={{ color: "rgba(255,255,255,0.72)" }}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-[13px] font-bold uppercase tracking-[0.14em] text-white">Services & Areas</h4>
          <ul className="mt-3 grid gap-1.5">
            {[...SERVICE_LINKS, { label: "Browse Store", href: "/store" }].map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-service-${l.href.replace("/", "")}`}
                   className="text-[14px] transition-colors hover:text-white"
                   style={{ color: "rgba(255,255,255,0.72)" }}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-[13px] font-bold uppercase tracking-[0.14em] text-white">Contact</h4>
          <div className="mt-3 grid content-start gap-2">
            <ContactLink testId="footer-phone" variant="footer" inverse />
            <ContactLink kind="email" testId="footer-email" variant="footer" inverse />
          </div>
        </div>
      </div>
      <div className="py-2.5 text-center text-[13px]"
           style={{ borderTop: "1px solid rgba(255,255,255,0.14)", color: "rgba(255,255,255,0.6)" }}>
        © 2026 Kapatia Pvt Ltd. All rights reserved. All trademarks belong to their respective owners.
      </div>
    </footer>
  );
}
